import React, {useState} from 'react';
import {
  albumSelector,
  getBasketPrice,
  getBasketQuantity,
} from '../../features/album/albumSlice';
import {useSelector} from 'react-redux';
import axios from 'axios';
import './Checkout.css';

function Checkout() {
  const {basket} = useSelector(albumSelector);
  const [firstName, setFirstName] = useState('');
  const [lastName, setlastName] = useState('');
  const [companyName, setcompanyName] = useState('');
  const [email, setEmail] = useState('');
  const [addressOne, setAddressOne] = useState('');
  const [addressTwo, setaddressTwo] = useState('');
  const [country, setCountry] = useState('');
  const [provance, setProvance] = useState('');
  const [district, setDistrict] = useState('');
  const [phonenumber, setPhonenumber] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const firstnameChange = (e) => setFirstName(e.target.value);
  const lastNameChange = (e) => setlastName(e.target.value);
  const companyNameChange = (e) => setcompanyName(e.target.value);
  const emailChange = (e) => setEmail(e.target.value);
  const addressOneChange = (e) => setAddressOne(e.target.value);
  const addressTwoChange = (e) => setaddressTwo(e.target.value);
  const countryChange = (e) => setCountry(e.target.value);
  const provanceChange = (e) => setProvance(e.target.value);
  const districtChange = (e) => setDistrict(e.target.value);
  const phoneChange = (e) => setPhonenumber(e.target.value);

  const makePaymentCall = async ({
    firstname,
    lastname,
    company,
    email,
    country,
    provance,
    district,
    phonenumber,
    amount,
  }) => {
    const response = await axios.post(
      `https://music-shop-backend.herokuapp.com/payment/create?total=${getBasketPrice(basket)}`,

      {
        firstname,
        lastname,
        company,
        email,
        country,
        provance,
        district,
        phonenumber,
        amount,
      }
    );
    return response.data;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (firstName && email) {
      setLoading(true);
      const result = await makePaymentCall({
        firstname: firstName,
        lastname: lastName,
        company: companyName,
        email,
        country,
        provance,
        district,
        phonenumber,
      });

      if (result.response.status === 'success') {
        return (window.location.href = result.response.data.link);
      } else {
        setError(result.response.message);
      }
    }
    setError('firstname and email is required');
  };

  return (
    <div className="checkout">
      <div className="container">
        <main>
          <div className="py-5 text-center">
            <h1 style={{paddingBottom: '1rem'}}>Official Bruce melody Store</h1>
            <h3>Checkout form</h3>
          </div>
          <div className="row g-5">
            <div className="col-md-5 col-lg-4 order-md-last">
              <h4 className="d-flex justify-content-between align-items-center mb-3">
                <span className="text-primary">Your cart</span>
                <span className="badge bg-primary rounded-pill">
                  {getBasketQuantity(basket)}
                </span>
              </h4>
              <ul className="list-group mb-3">
                {basket?.map((item) => (
                  <li
                    className="list-group-item d-flex justify-content-between lh-sm"
                    key={item.id}
                  >
                    <div>
                      <h6 className="my-0">Product name</h6>
                      <small className="text-muted">{item.title}</small>
                    </div>
                    <span className="text-muted">{item.price} RWF</span>
                  </li>
                ))}

                <li className="list-group-item d-flex justify-content-between">
                  <span>Total (RWF)</span>
                  <strong>{getBasketPrice(basket)} RWF</strong>
                </li>
              </ul>
            </div>
            <div className="col-md-7 col-lg-8">
              <h4 className="mb-3">Billing address</h4>
              <p style={{fontSize: '1.3rem'}}> {error && error}</p>
              <form
                className="needs-validation"
                novalidate=""
                onSubmit={handleSubmit}
              >
                <div className="row g-3">
                  <div className="col-sm-6">
                    <label for="firstName" className="form-label">
                      First name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="firstName"
                      placeholder="firstname"
                      value={firstName}
                      onChange={firstnameChange}
                    />
                    <div className="invalid-feedback">
                      Valid first name is required.
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <label for="lastName" className="form-label">
                      Last name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="lastName"
                      placeholder="lastname"
                      value={lastName}
                      onChange={lastNameChange}
                    />
                    <div className="invalid-feedback">
                      Valid last name is required.
                    </div>
                  </div>

                  <div className="col-12">
                    <label for="email" className="form-label">
                      Company Name{' '}
                      <span className="text-muted">(Optional)</span>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="Your Company"
                      value={companyName}
                      onChange={companyNameChange}
                    />
                    <div className="invalid-feedback">
                      Please enter a valid company name
                    </div>
                  </div>
                  <div className="col-12">
                    <label for="email" className="form-label">
                      Email
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="you@example.com"
                      value={email}
                      onChange={emailChange}
                    />
                    <div className="invalid-feedback">
                      Please enter a valid email address for shipping updates.
                    </div>
                  </div>

                  <div className="col-12">
                    <label for="address" className="form-label">
                      Address
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="address"
                      placeholder="1234 Main St"
                      value={addressOne}
                      onChange={addressOneChange}
                    />
                    <div className="invalid-feedback">
                      Please enter your shipping address.
                    </div>
                  </div>

                  <div className="col-12">
                    <label for="address2" className="form-label">
                      Address 2 <span className="text-muted">(Optional)</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="address2"
                      placeholder="Apartment or suite"
                      value={addressTwo}
                      onChange={addressTwoChange}
                    />
                  </div>
                  <div className="col-12">
                    <label for="address2" className="form-label">
                      Phone Number{' '}
                    </label>
                    <input
                      type="tel"
                      className="form-control"
                      id="phonenumber"
                      placeholder="phone number"
                      value={phonenumber}
                      onChange={phoneChange}
                    />
                  </div>

                  <div className="col-md-5">
                    <label for="country" className="form-label">
                      Country
                    </label>
                    <select className="form-select" id="country" required="">
                      <option value={country} onChange={countryChange}>
                        Choose...
                      </option>
                      <option>Rwanda</option>
                    </select>
                    <div className="invalid-feedback">
                      Please select a valid country.
                    </div>
                  </div>

                  <div className="col-md-4">
                    <label for="state" className="form-label">
                      Provance
                    </label>
                    <select className="form-select" id="state" required="">
                      <option value={provance} onChange={provanceChange}>
                        Choose...
                      </option>
                      <option>West</option>
                      <option>East</option>
                      <option>North</option>
                      <option>South</option>
                      <option>Kigali</option>
                    </select>
                    <div className="invalid-feedback">
                      Please provide a valid state.
                    </div>
                  </div>

                  <div className="col-md-3">
                    <label for="zip" className="form-label">
                      District
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="district"
                      placeholder="district"
                      value={district}
                      onChange={districtChange}
                    />
                    <div className="invalid-feedback">District required.</div>
                  </div>
                </div>

                <hr className="my-4" />

                <button className="w-100 btn btn-primary btn-lg" type="submit">
                  {loading ? 'processing' : 'Continue to checkout'}
                </button>
              </form>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default Checkout;
